import React from "react";
import { Fade, Slide } from "react-awesome-reveal";
import {
  FaHandHoldingHeart, // Fixed: Capitalized the 'H' in Holding
  FaMoon,
  FaKaaba,
  FaHandsPraying,
  FaSun,
} from "react-icons/fa6";

const pillars = [
  {
    title: "Shahada",
    arabic: "الشهادة",
    description:
      "The declaration of faith: 'There is no god but God, and Muhammad is the Messenger of God'.",
    icon: <FaMoon className="w-8 h-8" />,
  },
  {
    title: "Salah",
    arabic: "الصلاة",
    description:
      "The obligatory practice of ritual prayer performed five times a day facing the Kaaba.",
    icon: <FaHandsPraying className="w-8 h-8" />,
  },
  {
    title: "Zakat",
    arabic: "الزكاة",
    description:
      "The practice of giving a percentage of one's accumulated wealth to those in need.",
    icon: <FaHandHoldingHeart className="w-8 h-8" />,
  },
  {
    title: "Sawm",
    arabic: "الصوم",
    description:
      "The spiritual practice of self-restraint and fasting during daylight hours of Ramadan.",
    icon: <FaSun className="w-8 h-8" />,
  },
  {
    title: "Hajj",
    arabic: "الحج",
    description:
      "The sacred pilgrimage to the Holy Kaaba in Mecca, required once in a lifetime if able.",
    icon: <FaKaaba className="w-8 h-8" />,
  },
];

const FivePillars = () => {
  return (
    <div className="bg-gradient-to-br from-green-50/40 via-white to-stone-50 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12">
          <Fade direction="up" triggerOnce>
            <span className="text-sm font-semibold tracking-widest uppercase text-emerald-800 block mb-2">
              The Foundations of Faith
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-green-950 tracking-tight mb-4">
              Five Pillars of Islam
            </h2>
          </Fade>

          <Slide direction="up" triggerOnce>
            <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed text-base md:text-lg">
              The Five Pillars (
              <span className="font-medium text-emerald-900 font-sans">
                أركان الإسلام
              </span>{" "}
              —
              <span className="italic text-sm text-gray-500">
                {" "}
                arkān al-Islām
              </span>
              ) represent the core structural framework of a Muslim's life,
              mapping out the fundamental devotions required to sustain
              spiritual alignment.
            </p>
          </Slide>
        </div>

        {/* Pillars Grid Container */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 mt-12 justify-center">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className="group relative flex flex-col items-center bg-white border border-stone-100 shadow-sm rounded-2xl p-6 text-center transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
            >
              {/* Subtle top indicator border */}
              <div className="absolute top-0 inset-x-0 h-1 bg-gradient-to-r from-emerald-700 to-green-900 rounded-t-2xl opacity-0 group-hover:opacity-100 transition-opacity" />

              {/* Icon Container */}
              <div className="w-16 h-16 rounded-xl bg-emerald-50 text-emerald-800 flex items-center justify-center mb-5 group-hover:bg-emerald-900 group-hover:text-white transition-colors duration-300 shadow-inner">
                {pillar.icon}
              </div>

              {/* Titles */}
              <h3 className="text-xl font-bold text-gray-900 mb-0.5 tracking-tight group-hover:text-emerald-900 transition-colors">
                {pillar.title}
              </h3>
              <span className="text-sm text-emerald-700 font-serif mb-3 block opacity-85">
                {pillar.arabic}
              </span>

              {/* Description */}
              <p className="text-gray-500 text-sm leading-relaxed mt-auto">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FivePillars;
